<app-ticket-redeem [eventTicket]="share.admission" [service]="_ticketShareService" *ngIf="share" ></app-ticket-redeem>